import { Button } from "@blueprintjs/core"
import { useTranslation } from "react-i18next"

const ShowEntireRouteButton = ({
  onClick,
  disabled,
  className = "absolute left-[10px] top-[45px] z-10",
}: {
  onClick: () => void
  disabled: boolean
  /** Placement; the default is the old fixed spot for maps without a column */
  className?: string
}) => {
  const { t } = useTranslation()
  return (
    <div className={className}>
      <Button
        id="show-entire-route"
        disabled={disabled}
        onClick={onClick}
        icon="route"
        className="dark:bg-gray-700 dark:text-white"
        title={t("maps.showEntireRouteButton.title")}
      />
    </div>
  )
}

export default ShowEntireRouteButton
